
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspector",
      function () {
        return require("private-next-pages/inspector.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspector"])
      });
    }
  